import Vue from "vue"
import historyRecord from "@/components/global/historyRecord";

Vue.prototype.$historyRecord = historyRecord;
